import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from "react-router-dom";
import { post,get } from '../../helpers/api_helper';
import { img_view, IsModuleAccess } from '../../helpers/Helper';
import Loader from '../../component/Loader';
import { POST_ADD_EDIT_CATEGORY, POST_GET_CATEGORY_DETAIL, POST_GET_CATEGORY_FORM_OPTION } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { Helmet } from "react-helmet";
import { Link, useHistory } from "react-router-dom";

const ChangePassword = props => {
    let history = useHistory();
    if (!IsModuleAccess('category')) {
        history.push("/");
    }

    const [isLoader, setLoader] = useState(0);
    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [categoriesList, setCategoriesList] = useState([]);
    const [form_inputs, setInputs] = useState({ 'category_id': 0, 'category_name': '', 'image': '', 'parent_category_id': 0 ,'display_index' : 0});
    const [title, setTitle] = useState('Add Category');
    const [, forceUpdate] = useState();

    useEffect(() => {
        async function get_detaile() {
            await get_form_option();
            if (props.match.params.id) {
                setTitle('Edit Category');
                var res_data = await post(POST_GET_CATEGORY_DETAIL, { 'category_id': props.match.params.id }, {});
                if (res_data.status) {
                    setInputs(res_data.detail);
                } else {
                    toast.error(res_data.message);
                    history.push("/");
                }
            }
            setLoader(1);
        }
        get_detaile();
    }, [props.match.params.id])

    const get_form_option = async () => {
        var res_data = await get(POST_GET_CATEGORY_FORM_OPTION);
        if (res_data.status) {
            setCategoriesList(res_data.data.categories_list)
        } else {
            toast.error(res_data.message);
            history.push("/");
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_CATEGORY, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                history.push("/categories");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if (event.target.name === 'image') {
            var file_extension = event.target.files[0].name.split('.').pop();
            var file_size = event.target.files[0].size;
            var file_size = (file_size / 1024 / 1024).toFixed(1);

            var extension = ['png','jpg','jpeg'];
            if (!extension.includes(file_extension.toLowerCase())) {
                toast.error('Alludu only file png, jpg and jpeg.');
                event.target.value = null;
                return false;
            }

            if (file_size > 1) {
                toast.error('Max File size Allowed 1Mb.');
                event.target.value = null;
                return false;
            }

            var file = event.target.files[0];
            var reader = new FileReader();
            reader.onload = function () {
                setInputs(inputs => ({ ...form_inputs, [event.target.name]: reader.result }));
            }
            reader.readAsDataURL(file);
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }


    if (!isLoader) {
        return (<Loader></Loader>);
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Somerset Cafe | {title}</title>
            </Helmet>

            <div className='row mt-3'>
                <div className='col-sm-12'>
                    <div className='card'>
                        <div className="card-header">
                            <h6 className='m-0'>{title}</h6>
                        </div>
                        <div className='card-body'>
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-sm-6'>
                                        <div className="form-group mb-3">
                                            <label className="form-label text-capitalize">Select Parent Category</label>
                                            <select name="parent_category_id" value={form_inputs.parent_category_id} onChange={handleInputChange} className="form-control" >
                                                <option value="">Select Category</option>
                                                {categoriesList && Object.entries(categoriesList).map(([key, value]) => (
                                                    <option key={key} value={value.value}>{value.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="form-label text-capitalize">Category Name</label>
                                            <input name="category_name" value={form_inputs.category_name} onChange={handleInputChange} className="form-control" type="text" />
                                            {simpleValidator.current.message('Category name', form_inputs.category_name, 'required')}
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="form-label text-capitalize">Display Index</label>
                                            <input name="display_index" value={form_inputs.display_index} onChange={handleInputChange} className="form-control" type="text" />
                                            {simpleValidator.current.message('display index', form_inputs.display_index, 'required')}
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="form-label">Image <small className='ml-4'>Alludu file png, jpg and jpeg. Size 60px X 60px</small></label>
                                            <input name="image" onChange={handleInputChange} className="form-control" type="file" accept="image/*" />
                                        </div>
                                    </div>
                                    <div className='col-sm-6'>
                                        {form_inputs.img_url && <div className='form-group mb-3 text-center'>
                                            <img src={img_view(form_inputs.img_url, 100, 100)} width="50" />
                                        </div>}
                                    </div>
                                </div>
                                <div className="text-center mt-4">
                                    <button disabled={ButtonDisabled} type="submit" className='btn btn-primary c-btn-primary pt-1 pb-1 pl-3 pr-3'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Submit</button>
                                    <Link to="/categories" className='btn btn-danger c-btn-danger ml-3 pt-1 pb-1 pl-3 pr-3'>Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default withRouter(ChangePassword)
